import VideoCanvas from './video-canvas';
import { devLog, devError, delayPromise } from '../core/utils';
import { SUBMISSION_VIDEO_DRAW_SPEED } from '../core/config';

export default {
  name: 'video-thumbnails',
  mixins: [VideoCanvas],
  data() {
    return {
      thumbnails: [],
      thumbnailUrls: [],
    };
  },
  beforeDestroy() {
    this.thumbnails.forEach((url) => {
      URL.revokeObjectURL(url);
    });
  },
  methods: {
    /**
     * Update the size of the canvas,
     *
     * not using rt now
     */
    updateCanvasSize() {
      const canvas = this.checkEl('canvas');
      const video = this.checkEl('video');

      const {
        videoWidth,
        videoHeight,
      } = video;

      this.canvasWidth = videoWidth;
      this.canvasHeight = videoHeight;
      canvas.width = videoWidth;
      canvas.height = videoHeight;

      console.log(videoHeight, videoWidth);
    },

    /**
     * Handle video 'canplay' event
     *
     * @param {HTMLVideoElement} video
     */
    handleLoaded(video) {
      if (this.loaded) {
        return;
      }

      this.loaded = true;
      this.log('loaded');

      this.addFrame = this.addFrame.bind(this);

      video.removeEventListener('canplay', this.handleLoaded);
      video.addEventListener('seeked', this.addFrame, false);
      video.addEventListener('seeked', () => { this.log('seeked'); }, false);

      this.updateCanvasSize();

      // set marks
      this.setVideoMarks(video);

      this.getThumbnails(this.marks);
    },

    /**
     * Draw the current video frame to the canvas
     */
    draw(video, context) {
      this.log('draw');
      context.drawImage(video, 0, 0, this.canvasWidth, this.canvasHeight);
    },

    /**
     * Add a frame's image to the thumbnails for export
     *
     * @returns {String} url of the canvas image
     */
    addFrame() {
      this.log('add frame');
      this.draw();
      const out = this.exportImage();
      this.thumbnails.push(out);

      return out;
    },

    /**
     * Set thumnail images
     *
     * @param {Number} markIndex mark to use
     * @param {Number} totalMarks total marks to find
     *
     * @returns {Promise.<null>}
     */
    getThumbnail(markIndex, totalMarks) {
      return new Promise((resolve) => {
        this.goToMark(markIndex);
        // when I take this too fast faster its like the video doesn't seek
        // TODO: try an event listener on seeked for delay
        return delayPromise(SUBMISSION_VIDEO_DRAW_SPEED * 5).then(() => {
          if (markIndex < (totalMarks - 1)) {
            return this.getThumbnail(markIndex + 1, totalMarks)
              .then(() => resolve());
          }
          resolve();
          return null;
        });
      });
    },

    /**
     * Get images for all marks
     *
     * @returns
     */
    async getThumbnails(marks) {
      await this.getThumbnail(0, marks.length);

      this.exportThumbnails();
    },

    /**
     * Export thumbnail images
     *
     */
    exportThumbnails() {
      this.log(this.thumbnails);

      this.$emit('thumbnailExport', this.thumbnails);
    },

    /**
     * Log in dev
     *
     * @param {...*} logs
     */
    log: devLog.bind(this, 'Video Thumbnails: ', true),

    /**
     * Log error in dev
     *
     * @param {...*} logs
     */
    error: devError.bind(this, 'Video Thumbnails: ', true),
  }
};
